// @ts-nocheck
/* eslint-disable */
import MyMapsContextMenu from "~/es6/mymaps.contextmenu";

window.ContextMenu = class extends MyMapsContextMenu {
	constructor(opts) {
		super(opts);

		this._dom.container.classList.add("places");
		this._create(this._getNames());
	}

	/**
	 * Ziskani jmen tlacitek k vytvoreni.
	 *
	 * @return {Array[String]}
	 */
	_getNames() {
		let data = this._opts.data;
		let names = [];
		if (!this._opts.isDetail) {
			names.push("share");
		}
		if (data.type == "folder") {
			names.push("duplicate");
		}
		if (data.type == "entity" || data.type == "point") {
			names.push("navigate");
		}
		if (data.type == "folder") {
			names.push("rename");
		}
		else {
			names.push("edit");
		}
		if (data.type != "folder") {
			names.push("multiple");
		}
		if ((data.type == "folder" && this._opts?.data?.items?.length) || data.type == "route") {
			names.push("download");
		}
		if (data.type == "folder") {
			names.push("import");
		}
		if (data.type == "link" && data.linktype == "track") {
			names.push("remove");
		}
		else {
			names.push("delete");
		}

		return names;
	}
}
